import RegionList from '_modules/region/views/RegionList.vue';
import RegionCreate from '_modules/region/views/RegionCreate.vue';
import RegionEdit from '_modules/region/views/RegionEdit.vue';
import Region from './Root.vue';
import moduleMiddleware from '../../../router/middlewares/moduleMiddleware';

export default {
  path: 'regiao/',
  beforeEnter: moduleMiddleware('regions'),
  component: Region,
  name: 'admin-region-team',
  redirect: '/regiao/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-region-list',
      component: RegionList,
    },
    {
      path: 'nova/',
      name: 'admin-region-new',
      component: RegionCreate,
    },
    {
      path: ':id',
      name: 'admin-region-edit',
      component: RegionEdit,
    },
  ],
};
